import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { careersApi } from '../../services/api'
import PageMeta from '../../components/seo/PageMeta'
import LoadingSpinner from '../../components/ui/LoadingSpinner'
import JobApplicationForm from '../../components/careers/JobApplicationForm'
import { useLanguage } from '../../context/LanguageContext'
import { ensureEnglishForCareers } from '../../utils/careers'

export default function CareersListPage() {
  const { t, i18n } = useTranslation()
  const { language, setLanguage } = useLanguage()
  const [departments, setDepartments] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    ensureEnglishForCareers(language, setLanguage)
  }, [language, setLanguage])

  useEffect(() => {
    careersApi
      .getDepartments()
      .then(({ data }) => setDepartments(data.data || data || []))
      .catch(() => setDepartments([]))
      .finally(() => setLoading(false))
  }, [])

  const copy = i18n.getFixedT('en')

  return (
    <>
      <PageMeta
        title={copy('careers.metaTitle')}
        description={copy('careers.metaDescription')}
        path="/careers"
      />
      <div className="header-offset">
        <div className="gradient-brand py-12 text-white sm:py-16">
          <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-3xl font-bold sm:text-4xl"
            >
              {copy('careers.title')}
            </motion.h1>
            <p className="mx-auto mt-4 max-w-2xl text-white/80">{copy('careers.subtitle')}</p>
          </div>
        </div>

        <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
          {loading ? (
            <LoadingSpinner className="py-20" />
          ) : (
            <JobApplicationForm departments={departments} forceEnglish />
          )}
        </div>
      </div>
    </>
  )
}
